type Props = {
  assetTypes?: string[];
  counts?: Record<string, number>;
};

export function ProductCreativeGrid({ assetTypes = [], counts = {} }: Props) {
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {assetTypes.map((type) => (
        <button
          key={type}
          type="button"
          className="rounded-lg border border-slate-200 p-3 text-left transition hover:border-brand-300 hover:bg-brand-50/50 dark:border-slate-700 dark:hover:border-brand-800 dark:hover:bg-brand-950/30"
        >
          <p className="text-sm font-medium">{type}</p>
          {counts[type] !== undefined && (
            <p className="mt-1 text-xs text-slate-500">{counts[type]} assets</p>
          )}
        </button>
      ))}
    </div>
  );
}
